export const toInt = (s) => {
    const parsed = parseInt(s);
    if (isNaN(parsed)) {
        return null;
    }
    return parsed;
};
